export default function sizeCoverHeroImages() {
  document.querySelectorAll('picture[data-cover-image-ratio]').forEach((picture) => {
    const image = picture.querySelector('img[srcset]');
    const ratio = Number(picture.dataset.coverImageRatio);
    if (!image || !Number.isFinite(ratio) || ratio <= 0) return;

    const updateSizes = () => {
      const { width, height } = picture.getBoundingClientRect();
      const detailScale = Math.max(1, 1.2 / (window.devicePixelRatio || 1));
      const sizes = `${Math.ceil(Math.max(width, height * ratio) * detailScale)}px`;
      if (image.sizes !== sizes) image.sizes = sizes;
    };

    updateSizes();
    if ('ResizeObserver' in window) {
      new ResizeObserver(updateSizes).observe(picture);
    } else {
      window.addEventListener('resize', updateSizes);
    }

    const watchDisplayDensity = () => {
      const density = window.matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`);
      density.addEventListener('change', () => {
        updateSizes();
        watchDisplayDensity();
      }, { once: true });
    };
    watchDisplayDensity();
  });
}
